import React from 'react';

import {A} from 'views/AppElements';

class ProductTags extends React.Component {

	render() {
		const productTags = this.props.productTags;

		if(!productTags)
			return null;

		const tags = productTags.map(t => <A href={"/tag/"+t} key={t}>{t}</A>);
		return <div className='flexRow productTags'>{tags}</div>
	}
	
}

export default ProductTags;


// WEBPACK FOOTER //
// ./src/views/product/ProductTags.js